import Modal from 'react-modal'
import { VenueSuggestionDto } from '@ivy-monorepo/shared'
import { LocationMap } from '../locations/LocationView'
import { BaseModalProps } from '../../types/modal'

type VenueSuggestionDetailModalProps = BaseModalProps & {
  suggestion: VenueSuggestionDto | null
  onApprove: (suggestion: VenueSuggestionDto) => void
  onReject: (suggestion: VenueSuggestionDto) => void
  onOpenFeedback: (suggestion: VenueSuggestionDto) => void
}

const VenueSuggestionDetailModal = ({
  isOpen,
  onClose,
  suggestion,
  onApprove,
  onReject,
  onOpenFeedback,
}: VenueSuggestionDetailModalProps) => {
  const hasCoordinates = suggestion?.latitude != null && suggestion?.longitude != null
  const isPending = suggestion?.status === 'Pending'

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-popup venue-suggestion-modal"
      overlayClassName="modal-overlay"
      contentLabel="Venue suggestion"
    >
      <div className="modal-content-wrapper">
        <div className="modal-body-content">
          {suggestion && (
            <>
              <h3>{suggestion.name}</h3>

              <div className="venue-suggestion-detail-layout">
                {hasCoordinates ? (
                  <LocationMap
                    latitude={suggestion.latitude as number}
                    longitude={suggestion.longitude as number}
                    className="venue-suggestion-detail-map"
                    style={{ width: '100%', height: 260, borderRadius: 8 }}
                  />
                ) : (
                  <div className="venue-suggestion-detail-map-fallback">No pin was dropped for this suggestion.</div>
                )}

                <div className="venue-suggestion-detail-stats">
                  <dl>
                    <div>
                      <dt>Status</dt>
                      <dd>{suggestion.status}</dd>
                    </div>
                    {hasCoordinates && (
                      <div>
                        <dt>Coordinates</dt>
                        <dd>
                          {(suggestion.latitude as number).toFixed(5)}, {(suggestion.longitude as number).toFixed(5)}
                        </dd>
                      </div>
                    )}
                    <div>
                      <dt>Comment</dt>
                      <dd>{suggestion.comment || '—'}</dd>
                    </div>
                    <div>
                      <dt>Submitted by</dt>
                      <dd>
                        {suggestion.submittedByName} ({suggestion.submittedByEmail})
                      </dd>
                    </div>
                    <div>
                      <dt>Submitted</dt>
                      <dd>{new Date(suggestion.createdAt).toLocaleString()}</dd>
                    </div>
                    {suggestion.reviewedByName && (
                      <div>
                        <dt>Reviewed by</dt>
                        <dd>{suggestion.reviewedByName}</dd>
                      </div>
                    )}
                    {suggestion.reviewedAt && (
                      <div>
                        <dt>Reviewed</dt>
                        <dd>{new Date(suggestion.reviewedAt).toLocaleString()}</dd>
                      </div>
                    )}
                  </dl>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer-content">
          <button
            type="button"
            className="styled-button venue-suggestion-feedback-link"
            onClick={() => suggestion && onOpenFeedback(suggestion)}
          >
            Open feedback thread
          </button>
          <button type="button" className="styled-button" onClick={onClose}>
            Close
          </button>
          {isPending && (
            <>
              <button type="button" className="styled-button" onClick={() => suggestion && onReject(suggestion)}>
                Reject
              </button>
              <button type="button" className="styled-button" onClick={() => suggestion && onApprove(suggestion)}>
                Approve
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default VenueSuggestionDetailModal
